<template>
  <sc-form
    class="box is-paddingless"
    :form="quotingReturns"
    :rules="rules"
    @submit="save">
      <template slot="fields" slot-scope="{ fields }">
        <div class="columns">
          <div class="column is-6">
            <sc-field
              label="Gostaria de esconder os valores duplicados"
              prop="duplicates">
                <sc-switch v-model="fields.duplicates">
                  Sim
                </sc-switch>
            </sc-field>
          </div>
        </div>
        <div class="columns">
          <div class="column is-4">
            <sc-field
              label="Condições"
              prop="sort_type_id">
                <sc-select
                  v-model="fields.sort_type_id"
                  expanded>
                    <option
                      v-for="item in srcSortType"
                      :key="item.id"
                      :value="item.id">
                        {{ item.text }}
                    </option>
                </sc-select>
            </sc-field>
          </div>
        </div>
        <div class="columns">
          <div class="column is-4">
            <sc-field
              label="Ordem"
              prop="sort_mode">
                <sc-select
                  v-model="fields.sort_mode"
                  expanded>
                    <option
                      v-for="item in srcSortMode"
                      :key="item.id"
                      :value="item.value">
                        {{ item.text }}
                    </option>
                </sc-select>
            </sc-field>
          </div>
        </div>

        <div class="columns">
          <div class="column is-12 has-text-right">
            <sc-button
              type="submit"
              theme="primary"
              text="Salvar" />
          </div>
        </div>
      </template>
  </sc-form>
</template>

<script>
  import { Auth } from '@intelipost-js/secure-providers';
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScField,
    ScForm,
    ScInput,
    ScSelect,
    ScSwitch,
  } from '@intelipost-js/secure-components';
  import EnumSortDirection from '../../enum/EnumSortDirection.js';
  import EnumConditionalNormal from '../../enum/EnumConditionalNormal.js';


  const { mapState, mapActions } = createNamespacedHelpers('quote/quotingReturn');

  export default {
    name: 'sc-quoting-return-all',
    props: {
      returnModeType: {
        type: String,
        required: true,
      },
      typeId: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        rules: {
          sort_type_id: [
            {
              type: 'number',
              message: 'Informe a condição',
              required: true,
              trigger: 'input',
            },
          ],
          sort_mode: [
            {
              type: 'string',
              message: 'Informe a ordem',
              required: true,
              trigger: 'input',
            },
          ],
        },
      };
    },
    computed: {
      ...mapState([
        'quotingReturns',
      ]),
      srcSortMode() {
        return EnumSortDirection;
      },
      srcSortType() {
        return EnumConditionalNormal;
      },
    },
    methods: {
      ...mapActions([
        'updateQuotingReturnsAll',
      ]),
      getSortType(id) {
        return this.srcSortType.find(opt => opt.id === id);
      },
      getSortMode(val) {
        return this.srcSortMode.find(opt => opt.value === val);
      },
      save(frm = {}) {
        const sortType = this.getSortType(frm.sort_type_id);
        const sortMode = this.getSortMode(frm.sort_mode);

        this.updateQuotingReturnsAll(Object.assign(frm, {
          type_id: this.typeId,
          return_mode_type: this.returnModeType,
          quote_option_type: sortType.value,
          sort_type: sortMode.id,
          config_list: [],
          limit: 0,
          production: Auth.getUser().is_production,
        }));
      },
    },
    components: {
      ScForm,
      ScField,
      ScButton,
      ScInput,
      ScSelect,
      ScSwitch,
    },
  };
</script>

<style lang="scss" scoped>
  .align {
    &_right {
      justify-content: flex-end;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/quoting-return/components/sc-quoting-return-all/ScQuotingReturnAll.vue